import React, { ChangeEvent } from 'react'
import { TextInput, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface OtherOptionInputProps {
  value: string
  placeholder: string
  name: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  errorMessage?: string
  disabled?: boolean
}

export function OtherOptionInput({
  value,
  placeholder,
  name,
  onChange,
  errorMessage,
  disabled
}: OtherOptionInputProps): JSX.Element {
  return (
    <S.OtherOptionInputContainer>
      <TextInput
        hasError={!!errorMessage}
        messageError={errorMessage}
        name={name}
        placeholder={placeholder}
        onInputChange={onChange}
        value={value}
        maxLength={100}
        disabled={disabled}
      />
      <S.OtherOptionLengthDisplay>
        <Typography variant='content3'>{value?.length || 0}/100</Typography>
      </S.OtherOptionLengthDisplay>
    </S.OtherOptionInputContainer>
  )
}
